import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "search__ajax search__ajax--current-page" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.initialLoad)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.currentPage > 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("a", {
                  href: _ctx.getUrl(1),
                  rel: "start",
                  class: "search__ajax d-none d-inline-block-md",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(1)), ["prevent"]))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fi-left-open" }, null, -1 /* CACHED */),
                  _createTextVNode(" First ", -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_3),
                _createElementVNode("a", {
                  href: _ctx.getUrl(_ctx.currentPage - 1),
                  rel: "prev",
                  class: "search__ajax d-inline-block",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                }, _toDisplayString(_ctx.currentPage - 1), 9 /* TEXT, PROPS */, _hoisted_4)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.currentPage), 1 /* TEXT */),
          (_ctx.currentPage < _ctx.totalPages)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("a", {
                  href: _ctx.getUrl(_ctx.currentPage + 1),
                  rel: "next",
                  class: "search__ajax d-inline-block",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                }, _toDisplayString(_ctx.currentPage + 1), 9 /* TEXT, PROPS */, _hoisted_6),
                _createElementVNode("a", {
                  href: _ctx.getUrl(_ctx.totalPages),
                  class: "search__ajax d-none d-inline-block-md",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.totalPages)), ["prevent"]))
                }, [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Last ", -1 /* CACHED */),
                  _createElementVNode("i", { class: "fi-right-open" }, null, -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_7)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]))
  ]))
}